import React from "react";
import { SerializedCondition } from "../types";
import Input from "@/components/Input";

export type TimePassedCondition = {
  minutes: number;
  hours: number;
  days: number;
};

export function TimePassedEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const timeOnPageCondition = JSON.parse(
    condition.data || "{}"
  ) as TimePassedCondition;

  function update(data: TimePassedCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  return (
    <>
      <div className="flex gap-2 w-full items-center">
        <Input
          type="number"
          value={timeOnPageCondition.minutes}
          onChange={(minutes) => {
            update({ ...timeOnPageCondition, minutes: Number(minutes) });
          }}
        />
        <span>Minutes</span>
      </div>
      <div className="flex gap-2 w-full items-center">
        <Input
          type="number"
          value={timeOnPageCondition.hours}
          onChange={(hours) => {
            update({ ...timeOnPageCondition, hours: Number(hours) });
          }}
        />
        <span>Hours</span>
      </div>
      <div className="flex gap-2 w-full items-center">
        <Input
          type="number"
          value={timeOnPageCondition.days}
          onChange={(days) => {
            update({ ...timeOnPageCondition, days: Number(days) });
          }}
        />
        <span>Days</span>
      </div>
    </>
  );
}
